import { lazy } from 'react';
import { loader as maapLoader } from '../pages/MutualActionPlan/queries';

const CompanyView = lazy(() => import('../pages/CompanyView'));
const ConfirmationPage = lazy(() => import('../pages/Confirmation-page'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const MutualActionPlan = lazy(() => import('../pages/MutualActionPlan'));

// These are the routes that can be accessed by logged-in or non-logged-in users (in that case the search param contains the jwt)
export const defaultRoutes = (queryClient) => [
  {
    path: '/mutual-action-plan',
    element: <MutualActionPlan />,
    loader: maapLoader(queryClient),
  },
  {
    path: '/task_review',
    element: <MutualActionPlan />,
    loader: maapLoader(queryClient),
  },
  {
    path: '/company_view',
    element: <CompanyView />,
  },
  {
    path: '/confirmation/:user_created',
    element: <ConfirmationPage />,
  },
  {
    path: '/reset_password',
    element: <ForgotPassword />,
  },
  {
    path: '/sso-auth-callback',
    Component: () => {
      return (
        <div>
          <div>SSO Auth Callback</div>
        </div>
      );
    },
  },
];
